import { post } from "./base";
import { getLocalUserInfo } from '@/common/localstorage';

// 检测登录
export function checkLogin() {
    return new Promise((resolve) => {
        let userInfo = getLocalUserInfo();
        // console.log(userInfo);
        if (!userInfo) {
            return resolve(false);
        }
        // 将信息存在setting中
        window.setting.userInfo = userInfo;

        post('login.php', {
            username: userInfo.username,
            password: userInfo.password
        }).then((res) => {
            if (res.username == userInfo.username &&
                res.password == userInfo.password
            ) {
                return resolve(true);
            } else {
                return resolve(false);
            }
        })
    })
}

// 初始化队长
export function initStatusAndCaptain(myname) {
    return post('init_captain.php', {
        username: myname
    });
}

// 离线
export function postOutline(myname) {
    return post('set_outline_status.php', {
        username: myname
    });
}

// 设置除离线外其他的状态
export function postOnline(myname, status) {
    return post('set_online_status.php', {
        username: myname,
        status: status
    });
}

// 修改加载的战术
export function postTacticCurrent(current) {
    return post('set_tactic_current.php', {
        current: current
    });
}

// 发送消息
export function postSay(username, content) {
    return post('set_say.php', {
        username: username,
        content: content
    });
}

// 设置队长
export function postCaptain(username) {
    return post('set_captain.php', {
        username: username
    });
}
